<div *ngIf="widget.data.embedCode" [innerHtml]="widget.data.embedCode|safe"></div>
